import { User } from "firebase/auth";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthProvider";
import { useQuery } from "@tanstack/react-query";
import { UserSubscriptionStatsApiResponse } from "../../DataModels/DataModels";
import ApiInterface from "./api-interface";
import { API_HTTP, resumeAnalyzerApiEndpoints } from "./endpoints";

const MS = {
	FIVE_MINUTES: 5 * 60 * 1000
};

export const useUserSubscriptionStats = () => {
	const authContext = useContext(AuthContext);
	const user: User | null = authContext?.user as User;

	const userSubscriptionStatsQuery = useQuery<UserSubscriptionStatsApiResponse>(
		{
			queryKey: ["user", user?.uid, "subscription-stats"],
			queryFn: async (): Promise<UserSubscriptionStatsApiResponse> => {
				if (!user?.uid) throw new Error("User not authenticated");
				const apiClient = new ApiInterface(API_HTTP.resumeAnalyzer, user);
				const res = await apiClient.get(
					resumeAnalyzerApiEndpoints.userSubscriptionStats
				);
				return res;
			},
			enabled: !!user?.uid,
			staleTime: MS.FIVE_MINUTES
		}
	);

	return {
		subscriptionStats: userSubscriptionStatsQuery.data,
		isLoading: userSubscriptionStatsQuery.isLoading,
		isError: userSubscriptionStatsQuery.isError
	};
};
